import { theme } from "../theme";

const textWidth = 216

export const signIn = {
  wrapper: {
    background: "linear-gradient(180deg, #7BB325 0%, #1A7C65 100%)",
    paddingTop: "7em",
    height: "100vh",
    overflow: "auto",
    '@media (max-height: 768px)': {
      paddingTop: "3em", // Adjust height for smaller screens
    },
  },
  avatar: {
    width: "46px",
    height: "46px",
    position: "absolute",
    top: "-23px",
    left: "calc(50% - 23px)",
    zIndex: 1,
  },
  card: {
    width: "310px",
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    overflow: "visible",
    textAlign: "center",
    padding: "40px 30px",
  },
  googleBtn: {
    color: "#202020",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "18px",
    padding: "5px 25px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "14px",
    width: `${textWidth}px`
  },
  textStyle: { background: "#fff", position: "relative", zIndex: 1, width: "135px", margin: "auto" },
  headingDiv: { width: `${textWidth}px`, textAlign: "center", margin: "auto" },
  linkBtn: {
    textDecoration:"underline",
    "&:hover": {
      textDecoration:"underline",
      color: theme.palette.primary.main,
    },
    fontSize: "11px",
  }
} as const;

export const topAppBar = {
  avatar: {
    width: 32,
    height: 32,
    marginLeft: theme.spacing(4),
  },
  appBar: {
    height: "60px",
    backgroundColor: "#fff",
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize,
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    minHeight: "60px",
  },
  refreshButton: {
    textTransform: "initial",
    color: theme.palette.text.primary,
  },
} as const;

export const sidebarMenu = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingTop: 2,
    '& .MuiMenuItem-root': {
      '&.RaMenuItemLink-active': {
        borderLeft: "4px solid #7BB225",
        color: "#242424 !important",
      }
    },
  },
} as const;